import { augmentedWrap } from './utils';

export const addTheme = (content, selectedVariant, preserveOverrides) =>
  augmentedWrap(content)
    .updateStyle('config.style', { theme: selectedVariant }, preserveOverrides)
    .value();
